import { render } from "./ModalPassword.vue?vue&type=template&id=9f6fe15c"
import script from "./ModalPassword.vue?vue&type=script&lang=js"
export * from "./ModalPassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\inetpub\\wwwroot\\frontend\\employer-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__